export const API_URL_SUFFIX_LENGTH = 3;
